const T = require("react").PropTypes;

const audit = T.shape({
    AuditID: T.string.isRequired,
    AuditName: T.string
});

const auditPeriod = T.shape({
    AuditPeriod: T.string.isRequired,
    Audits: T.arrayOf(audit).isRequired
});

const facilityAuditList = T.shape({
    FacilityNumber: T.string.isRequired,
    AuditPeriods: T.arrayOf(auditPeriod).isRequired
});

/**
 * Specifies metadata for Caudit uploads.
 * 
 * Type gives us a shape to use in validating data passed to the component.
 * 
 * GetSpecData() generates a "Data" object for a MetadataSpec.
 */
const CauditData = {
    // Factory method
    GetSpecData() {
        const spec = {
            Targets: {
                Loading: false,
                Loaded: false,
                Data: [],
                Error: null
            },
            Target: null,
            IsComplete: false,
            Arg: null
        };

        return spec;
    },
    // This should mirror the spec type.
    Type: T.shape({
        Targets: T.shape({
            Loading: T.bool,
            Loaded: T.bool,
            Data: T.arrayOf(facilityAuditList),
            Error: T.object
        }),
        Target: T.string
    })
};

module.exports = CauditData;


// WEBPACK FOOTER //
// ./src/types/metadata/CauditData.js